import React, { memo } from 'react';
import { Control } from 'react-hook-form';
import { EvaluationFieldType, EvaluationFieldProps } from '../../types/Evaluation';
import {
  SingleSelectInput,
  MultiSelectInput,
  TextInput,
  SwitchInput,
  DateInput,
  NumberInput,
  MultiTextInput,
  ColorSwatch
} from '../../atoms/evaluation-inputs';

/**
 * Maps each field type string to its corresponding input component.
 * To add a new field type, add an entry here and create the input component.
 */
const FIELD_COMPONENT_MAP: Record<EvaluationFieldType, React.ComponentType<EvaluationFieldProps>> = {
  Singleselect: SingleSelectInput,
  Multiselect: MultiSelectInput,
  Text: TextInput,
  Boolean: SwitchInput,
  Date: DateInput,
  Float: NumberInput,
  MultipleTexts: MultiTextInput,
  Color: ColorSwatch,
  NUMERIC: NumberInput,
  TEXT: TextInput,
  SELECT: SingleSelectInput,
  COLOR: ColorSwatch,
  TEXT_MULTI: MultiTextInput,
  DATE: DateInput,
  MULTISELECT: MultiSelectInput,
  NUMBER: NumberInput,
};

interface FieldRendererProps {
  name: string;
  label: string;
  type: EvaluationFieldType;
  control: Control<any>;
  selectionMessage?: string;
  options?: string[];
  readOnly?: string | boolean | null;
  possibleValues?: Record<string, any>;
}

/**
 * Dynamically renders the correct input component based on the field type.
 * Uses FIELD_COMPONENT_MAP instead of switch/if-else for scalability.
 */
function FieldRenderer({ name, label, type, control, selectionMessage, options, readOnly, possibleValues }: FieldRendererProps) {
    const Component = FIELD_COMPONENT_MAP[type];

    if (!Component) {
        console.warn(`FieldRenderer: Unknown field type "${type}" for field "${label}"`);
        return null;
    }

    return (
        <Component
        name={name}
        control={control}
        label={label}
        selectionMessage={selectionMessage}
        options={options}
        readOnly={readOnly}
        possibleValues={possibleValues}
        />
    );
}

export default memo(FieldRenderer);
